export const shouldLoad = () => document.querySelector('[data-controller="card-action-selection"') !== undefined;
